import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { PlusSVG } from '../svg/plus.svg';

const PlusIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <PlusSVG/>
    </div>
  );
};

export { PlusIcon };
